const loc_es_strings = {
    "Login": {
        "HEADING": "Iniciar sesión en la plataforma MM-ID",
        "LOGIN": "Iniciar sesión",
        "USER": "Usuario",
        "PASSWORD": "Contraseña",
        "LOGIN_FAIL": "Error al iniciar sesión",
        "LOGIN_FIELD_REQUIRED": "El campo \"Nombre de usuario\" es obligatorio",
        "PASSWORD_FIELD_REQUIRED": "El campo \"Contraseña\" es obligatorio",
        "FORGOT_PASSWORD": "¿Olvidó su contraseña?",
        "DIFFERENT_ACCOUNT": "Registrarse con una cuenta diferente",
        "NO_ACCOUNT": "¿No tiene una cuenta?",
        "REGISTER": "Registrarse en MM digital",
        "CHANGE_DENIED_TEXT": "Use p. ej. OWA para cambiar su contraseña AD o póngase en contacto con el Servicio de Asistencia."
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Cuadro de mando",
        "ACTION_TEXT": "Acciones",
        "CHANGE_PASSWORD_TEXT": "Cambiar contraseña",
        "MY_APPLICATIONS_TEXT": "Mis aplicaciones MM",
        "APPLICATIONS_TEXT": "Aplicaciones MM",
        "USERS_LIST_TEXT": "Gestión de usuarios"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Cuadro de mando",
        "MY_APPLICATIONS_TEXT": "Mis aplicaciones MM",
        "APPLICATIONS_TEXT": "Aplicaciones MM"
    },
    "Header": {
        "USER_MENU_TEXT": "Menú del usuario",
        "ACTION_TEXT": "Acciones",
        "CHANGE_PASSWORD_TEXT": "Cambiar contraseña",
        "USERS_LIST_TEXT": "Gestión de usuarios",
        "USER_GROUPS": "Roles"
    },
    "Credentials": {
        "OLD_PASSWORD": "Contraseña anterior",
        "NEW_PASSWORD": "Nueva contraseña",
        "CONFIRM_PASSWORD": "Confirmar contraseña",
        "PASS_DO_NOT_MATCH": "Las contraseñas no coinciden",
        "PASSWORD_FIELD_REQUIRED": "El campo \"Contraseña\" es obligatorio",
        "OLD_PASSWORD_FIELD_REQUIRED": "El campo \"Contraseña anterior\" es obligatorio",
        "SUCCESS_TEXT": "La contraseña se ha cambiado con éxito",
        "HEADING": "Cambiar crendenciales MM-ID",
        "HELP": "¿Necesita ayuda?",
        "SAVE": "Cambiar",
        "CANCEL": "Cancelar",
        "PASSWORD_CHANGE_ERROR": "La información no pudo guardarse. Inténtelo mas tarde.",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "La contraseña debe tener un mínimo de 10 símbolos y contener mayúsculas, minúsculas, caracteres especiales y números",
        "PASSWORD_REQUIREMENTS_TEXT": "La contraseña debe cumplir con los siguientes requisitos:",
        "LOWERCASE_LETTER_TEXT": "Al menos una letra minúscula",
        "UPPERCASE_LETTER_TEXT": "Al menos una letra mayúscula",
        "NUMBER_TEXT": "Al menos un número",
        "SPECIAL_SYMBOL_TEXT": "Al menos un símbolo",
        "PASSWORD_LENGTH_TEXT": "Contener al menos 10 caracteres",
        "PASSWORD_RESTRICTION_TEXT": "El apellido, el nombre o el nombre de usuario no deben ser parte de la contraseña",
        "CHANGE_PASSWORD_TEXT": "Cambiar contraseña",
        "ACTION_TEXT": "Acciones",
        "CHANGE_DENIED_TEXT": "Use p. ej. OWA para cambiar su contraseña AD o póngase en contacto con el Servicio de Asistencia."
    },
    "CreatePassword": {
        "PASSWORD": "Crear una contraseña",
        "CONFIRM_PASSWORD": "Confirmar contraseña",
        "PASS_DO_NOT_MATCH": "Las contraseñas no coinciden",
        "PASSWORD_FIELD_REQUIRED": "El campo \"Contraseña\" es obligatorio",
        "SUCCESS_TEXT": "La información se ha guardado con éxito",
        "HEADING": "Crear constraseña",
        "HELP": "¿Necesita ayuda?",
        "SAVE": "Cambiar",
        "CANCEL": "Cancelar",
        "PASSWORD_CHANGE_ERROR": "La información no pudo guardarse. Inténtelo mas tarde.",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "La contraseña debe tener un mínimo de 10 símbolos y contener mayúsculas, minúsculas, caracteres especiales y números",
        "PASSWORD_REQUIREMENTS_TEXT": "La contraseña debe cumplir con los siguientes requisitos:",
        "LOWERCASE_LETTER_TEXT": "Al menos una letra minúscula",
        "UPPERCASE_LETTER_TEXT": "Al menos una letra mayúscula",
        "NUMBER_TEXT": "Al menos un número",
        "SPECIAL_SYMBOL_TEXT": "Al menos un símbolo",
        "PASSWORD_LENGTH_TEXT": "Contener al menos 10 caracteres",
        "PASSWORD_RESTRICTION_TEXT": "El apellido, el nombreo o el nombre de usuario no deben ser parte de la contraseña",
        "PASSWORD_WAS_SET": "El enlace ya ha sido usado para establecer la contraseña, si no recuerda la contraseña, utilice la función de restablecimiento de contraseña.",
        "OLD_PASSWORD_REQUIRED": "El campo \"Contraseña anterior\" es obligatorio.",
        "MMID_CHANGE_PASSWORD": "Cambiar contraseña",
        "OLD_PASSWORD": "Contraseña anterior",
        "INVALID_OLD_PASSWORD": "Contraseña anterior inválida",
        "USER_NOT_FOUND_OR_INACTIVE": "Usuario no encontrado o inactivo",
        "UNKNOWN_ERROR": "Se ha producido un error al cambiar la contraseña"
    },
    "ForgotPassword": {
        "USER": "Correo electrónico",
        "LOGIN_FAIL": "Introduzca la dirección de correo electrónico correcta",
        "LOGIN_FIELD_REQUIRED": "El campo \"Correo electrónico\" es obligatorio",
        "HEADING": "Olvidé mi contraseña",
        "HELP": "¿Necesita ayuda?",
        "SAVE": "Enviar correo electrónico de restablecimiento de contraseña",
        "CANCEL": "Cancelar",
        "SUCCESS_TEXT": "Le hemos enviado un correo electónico, compruebe su bandeja de entrada.",
        "CHANGE_DENIED_TEXT": "Use p. ej. OWA para cambiar su contraseña AD o póngase en contacto con el Servicio de Asistencia.",
        "PASSWORD_RESET_TOO_OFTEN": "La función de restablecimiento de contraseña se ha usado muchas veces, inténtelo más tarde",
        "RESET_FAILED": "Error al iniciar sesión",
        "LINK_EXPIRED": "El enlace de inicio de sesión ha expirado. Introduzca su dirección de correo electrónico para solicitar nuevamente el enlace de inicio de sesión.",
        "HEADING_EXPIRED": "El enlace de inicio de sesión ha expirado",
        "SAVE_EXPIRED": "Solicitar el enlace de inicio de sesión"
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Gestión de usuarios",
        "ACTIVE": "Activo",
        "INACTIVE": "Inactivo",
        "MMID": "MMID",
        "EXTRANET": "Usuarios externos",
        "OU": "Unidad organizacional",
        "ORGANIZATION_UNIT": "Unidad organizativa",
        "LANGUAGE": "Idioma",
        "OPEN_FILTER": "Abrir filtro",
        "CLOSE_FILTER": "Cerrar filtro",
        "RESET": "restablecer",
        "RESET_ALL_FILTERS": "restablecer todos los filtros",
        "SEARCH": "Buscar",
        "STATUS": "Estado",
        "GROUPS": "Grupos",
        "SHOW_ALL_DETAILS": "Mostrar todos los detalles",
        "SHOW_LESS": "Mostrar menos",
        "ASCENDING": "Ascendente",
        "DESCENDING": "Descendente",
        "LIST_END": "Fin de la lista",
        "SORT_BY_LASTNAME": "Ordenar por apellido",
        "SORT_BY_FIRSTNAME": "Ordenar por nombre",
        "SORT_BY_EMAIL": "Ordenar por correo electrónico",
        "SORT_BY_LANGUAGE": "Ordenar por idioma preferido",
        "SORT_BY_STATUS": "Ordenar por estado",
        "SORT_BY_OU": "Ordenar por UO",
        "SORT_BY_ACCOUNT_NAME": "Sort by Logon Name",
        "EDIT": "Editar",
        "CREATE": "Nuevo usuario",
        "DIGICREATE": "Nuevo usuario MM digital",
        "EXTRANETCREATE": "Nuevo usuario de extranet de MM SharePoint",
        "MMPCREATE": "Nuevo usuario MMP digital",
        "ACTIVATE": "Activar",
        "DEACTIVATE": "Desactivar",
        "USER_WAS_ACTIVATED": "El usuario fue desactivado",
        "USER_WAS_DEACTIVATED": "El usuario fue desactivado",
        "ERROR_USER_ACTIVATION": "Se produjo un error durante la activación del usuario",
        "ERROR_USER_DEACTIVATION": "Se produjo un error durante la desactivación del usuario",
        "SEND_FORGOT_PW_EMAIL": "Enviar correo electrónico de \"Olvidé mi contraseña\"",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Correo electrónico genérico de \"Olvidé mi contraseña\"",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Correo electrónico de \"Olvidé mi contraseña\" de MM digital",
        "SEND_FORGOT_PW_EMAIL_MMP": "Correo electrónico de \"Olvidé mi contraseña\" de MMP digital",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "Correo electrónico de \"Olvidé mi contraseña\" SP",
        "COMPANY": "Empresa",
        "SEND_WELCOME_EMAIL": "Enviar correo electrónico de bienvenida",
        "SEND_WELCOME_EMAIL_DIGI": "Correo electrónico de bienvenida de MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Correo electrónico de bienvenida de MM digital sin botón de contraseña",
        "SEND_WELCOME_EMAIL_MMP": "Correo electrónico de bienvenida de MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "Correo electrónico de bienvenida de MMP digital sin botón de contraseña",
        "SEND_WELCOME_EMAIL_EXTRANET": "Correo electrónico de bienvenida SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "Correo electrónico de bienvenida SP sin botón de contraseña",
        "APPLY_FILTER_FOR_USERS": "Use los filtros o la búsqueda para mostrar los resultados",
        "GENERATING_EMAIL": "Generando correo electrónico ....",
        "ERROR_EMAIL_GENERATE": "Error al generar un correo electrónico ....",
        "LOCKED": "Locked",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "PHYSICAL_LOCATION": "Location",
        "REQUIRED": "Required",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Gestión de usuarios",
        "USER_WAS_ACTIVATED": "Se activó el usuario",
        "USER_WAS_DEACTIVATED": "Se desactivó el usuario",
        "ERROR_USER_ACTIVATION": "Se produjo un error durante la activación del usuario",
        "ERROR_USER_DEACTIVATION": "Se produjo un error durante la desactivación del usuario",
        "LOADING_USER_ERROR": "Se produjo un error al cargar el usuario",
        "FIRSTNAME": "Nombre",
        "LASTNAME": "Apellido",
        "EMAIL": "Correo electrónico",
        "ACCOUNT_NAME": "Nombre de inicio de sesión del usuario (pre-windows 2000)",
        "LANGUAGE": "Idioma",
        "PRINCIPAL_NAME": "Nombre del usuario principal",
        "OU": "Unidad organizativa",
        "CLASS_DISPLAY_NAME": "Nombre para mostrar",
        "PHONE": "Teléfono",
        "WEBSITE": "Página web",
        "COUNTRY": "País",
        "STATE": "Estado",
        "LOCATION": "Ciudad",
        "STREET": "Calle",
        "POSTAL_CODE": "Código postal",
        "COMPANY": "Empresa",
        "DEPARTMENT": "Departamento",
        "PERSONAL_TITLE": "Tratamiento personal",
        "MANAGER": "Director",
        "DESCRIPTION": "Descripción",
        "GROUPS": "Grupos",
        "SAVE": "Guardar",
        "CANCEL": "Cancelar",
        "USER_STATUS": "Estado del usuario",
        "ACTIVE": "Activo",
        "INACTIVE": "Inactivo",
        "ACTIVATE": "Activar",
        "DEACTIVATE": "Desactivar",
        "USER_WAS_SAVED": "Se guardó el usuario",
        "UNKNOWN_ERROR": "Se ha producido un error desconocido al guardar el usuario",
        "PROXY_ADDRESSES": "Direcciones proxy",
        "BROWSE": "Examinar",
        "REMOVE": "Eliminar",
        "ONLY_JPG": "¡Solo se permiten imágenes jpg!",
        "FILE_SIZE": "¡El tamaño del archivo debe ser menor que 100 KB!",
        "DIMENSIONS": "¡Las dimensiones máximas de la imagen deben ser 96x96 pixeles!",
        "SEND_FORGOT_PW_EMAIL": "Enviar correo electrónico de \"Olvidé mi contraseña\"",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Correo electrónico genérico de \"Olvidé mi contraseña\"",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Correo electrónico MM digital de \"Olvidé mi contraseña\"",
        "SEND_FORGOT_PW_EMAIL_MMP": "Correo electrónico MMP digital de \"Olvidé mi contraseña\"",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "Correo electrónico \"Olvidé mi contraseña\" SP",
        "VIRUS_FOUND": "No se pudo guardar el usuario. Se encontró un malware en el adjunto. El archivo no se cargará. Póngase en contacto con el administrador del sistema.",
        "VIRUS_SCANNER_NOT_AVL": "No se pudo analizar el archivo por malware. Inténtelo más tarde. Si el problema persiste, póngase en contacto con el administrador del sistema.",
        "INFO": "Acerca de",
        "SEND_WELCOME_EMAIL": "Enviar correo electrónico de bienvenida",
        "SEND_WELCOME_EMAIL_DIGI": "Correo electrónico de bienvenida de MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Correo electrónico de bienvenida de MM digital sin botón de contraseña",
        "SEND_WELCOME_EMAIL_MMP": "Correo electrónico de bienvenida de MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "Correo electrónico de bienvenida de MMP digital sin botón de contraseña",
        "SEND_WELCOME_EMAIL_EXTRANET": "Correo electrónico de bienvenida SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "Correo electrónico de bienvenida SP sin botón de contraseña",
        "SAVING_USER_SPINNER": "Guardando el usuario... Por favor, espere",
        "DUPLICATE_USER": "El usuario ya existe",
        "GENERATING_EMAIL": "Generando correo electrónico ....",
        "ERROR_EMAIL_GENERATE": "Error al generar un correo electrónico ....",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "COST_CENTER": "Cost center",
        "JOB_TITLE": "Job title",
        "GENDER": "Gender",
        "USER_NOT_FOUND": "Usuario no encontrado",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Generando un correo electrónico de bienvenida ...."
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "Se activó el usuario",
        "USER_WAS_DEACTIVATED": "Se desactivó el usuario",
        "ERROR_USER_ACTIVATION": "Se produjo un error durante la activación del usuario",
        "ERROR_USER_DEACTIVATION": "Se produjo un error durante la desactivación del usuario",
        "EMAIL_WAS_SENT": "El correo electrónico fue enviado con éxito",
        "EMAIL_NOT_SENT_USER_ACTIVE": "No se envió el correo electrónico. El usuario ya está activo. En su lugar, use la función de enviar correo electrónico de \"Olvidé mi contraseña\"",
        "ERROR_EMAIL_SEND": "Error al intentar enviar el correo electrónico",
        "EMAIL_NOT_SENT_USER_INACTIVE": "No se envió el correo electrónico. El usuario está inactivo. Use la función de enviar correo registro en MM digital",
        "PASSWORD_RESET_TOO_OFTEN": "La función de restablecimiento de contraseña se ha usado muchas veces, inténtelo más tarde",
        "USER_WAS_UNLOCKED": "User was unlocked",
        "ERROR_UNLOCK_USER": "Error unlocking user"
    }
};

export default loc_es_strings;



// WEBPACK FOOTER //
// ./src/resources/es.js